import { FuseNavigation } from "@fuse/types";
import { isModuleMigrated } from "../base-module/base-service/front-novo.config";

/**
 * Escolhe, em build-time, a forma do menu de um módulo conforme a flag de migração do
 * ambiente: retorna `novoNode` quando o módulo está migrado ([[isModuleMigrated]]), senão
 * `legacyNode`. Governa o menu pela **mesma** fonte de verdade do guard de rota, evitando
 * divergência (ex.: item único no menu com o redirect desligado).
 *
 * Para migrar um módulo novo: defina seus dois nós e envolva-os aqui em `navigation.ts`,
 * usando a mesma `key` registrada em `FRONT_NOVO_MODULES`.
 *
 * @param key Chave do módulo em `FRONT_NOVO_MODULES` (ex.: `"clientes"`).
 * @param legacyNode Nó do menu na implementação antiga (front velho).
 * @param novoNode Nó do menu quando o módulo já vive no front novo.
 */
export function pickFrontNovoMenu(
    key: string,
    legacyNode: FuseNavigation,
    novoNode: FuseNavigation,
): FuseNavigation {
    return isModuleMigrated(key) ? novoNode : legacyNode;
}
